import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isEnabledForFrontierCopilotAudience } from './isEnabledForFrontierCopilotAudience';

export function isFormAppContextEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        isGlobalFeatureEnabled('cal-copilot-form-appcontext') ||
        isFormAppContextFrontierEnabled(mailboxInfo)
    );
}

export function isFormAppContextFrontierEnabled(mailboxInfo: MailboxInfo): boolean {
    return isEnabledForFrontierCopilotAudience(mailboxInfo, {
        publicFlight: 'cal-copilot-form-appcontext-frontier-public',
        privateTapFlight: 'cal-copilot-form-appcontext-frontier-private-tap',
        privateStagingFlight: 'cal-copilot-form-appcontext-frontier-private-staging',
        privateInfluencerFlight: 'cal-copilot-form-appcontext-frontier-private-influencer',
    });
}
